import { InjectionToken } from "@angular/core";
import { CONFIG_SERVICE_ENABLE_PREPROCESSOR } from "@obg/global";

import { GlobalConfig } from "./model";

export const GLOBAL_CONFIG = new InjectionToken<GlobalConfig>("globalConfig");
export const CONFIG_SERVICE_ENABLE_PREPROCESSOR_INJECTION_TOKEN = new InjectionToken<boolean>(
	CONFIG_SERVICE_ENABLE_PREPROCESSOR
);

/**
 * @internal
 */
export const _GLOBAL_CONFIG = new InjectionToken<GlobalConfig | (() => GlobalConfig)>("_globalConfig");

export const OPTIMIZELY_FEATURE_FLAGS = new InjectionToken<Record<string, any>>("optimizelyFeatureFlags");
